import { render, staticRenderFns } from "./settingsBankAccountInfoModal.vue?vue&type=template&id=cf21a490&scoped=true&"
import script from "./settingsBankAccountInfoModal.vue?vue&type=script&lang=js&"
export * from "./settingsBankAccountInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./settingsBankAccountInfoModal.vue?vue&type=style&index=0&id=cf21a490&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf21a490",
  null
  
)

export default component.exports